import { NavLink } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { MOBILE_ITEMS } from "./navItems";

export default function MobileNav({ user }) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-[#1A1A1E]/95 backdrop-blur-xl border-t border-[#3F3F4C]">
      <div className="flex justify-around items-center py-1.5">
        {MOBILE_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            data-testid={`mobile-${item.testid}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 px-2 py-1.5 min-h-[52px] ${
                isActive ? "text-[#FF1E27]" : "text-gray-500"
              }`
            }
          >
            <item.icon className="w-5 h-5" />
            <span className="font-body-sport text-[8px] font-bold tracking-wider uppercase">
              {item.label}
            </span>
          </NavLink>
        ))}
        {user?.role === "admin" && (
          <NavLink
            to="/admin"
            data-testid="mobile-nav-admin"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 px-2 py-1.5 min-h-[52px] ${
                isActive ? "text-[#FFB703]" : "text-gray-500"
              }`
            }
          >
            <ShieldCheck className="w-5 h-5" />
            <span className="font-body-sport text-[8px] font-bold tracking-wider uppercase">
              Admin
            </span>
          </NavLink>
        )}
      </div>
    </nav>
  );
}
